import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.css';

const Toggle = ({
  checked = false,
  onChange,
  label = '',
  labelPlacement = 'end',
  name = '',
  disabled = false,
  className = '',
}) => {
  const handleChange = (e) => {
    if (onChange && !disabled) {
      onChange({
        target: {
          name: name,
          checked: e.target.checked,
        },
      });
    }
  };

  return (
    <div
      className={`${styles.switchContainer} ${
        labelPlacement === 'start' ? styles.labelStart : styles.labelEnd
      } ${disabled ? styles.disabled : ''} ${className}`.trim()}
    >
      {label && labelPlacement === 'start' && (
        <label htmlFor={name || undefined} className={styles.label}>
          {label}
        </label>
      )}
      <label className={styles.switch}>
        <input
          type="checkbox"
          id={name || undefined}
          name={name}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          className={styles.input}
        />
        <span className={styles.slider} aria-hidden />
      </label>
      {label && labelPlacement === 'end' && (
        <label htmlFor={name || undefined} className={styles.label}>
          {label}
        </label>
      )}
    </div>
  );
};

Toggle.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  labelPlacement: PropTypes.oneOf(['start', 'end']),
  name: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default Toggle;
